export default __webpack_public_path__ + "assets/images/bfa067388b6f0f4747fa28fd0926318a.svg";